import { createContext } from "react";
import type { ToastType } from "../types/toast";

export type ToastContextType = {
  addToast: (message: string, type: ToastType) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export { ToastContext };
